import { Routes } from '@angular/router';
import { DocumentsComponent } from './documents.component';

export const DOCUMENTS_ROUTES: Routes = [
    {
        path: '',
        component: DocumentsComponent,
        data: {
            menu: {
                icon: 'folder',
                libelle: 'menu.documents'
            }
        }
    }
];
